import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DivineServiceDetailDto } from '../../models/divine-service.model';
import { UserFullInfoService } from '@core/services/user-full-info.service';

@Component({
    selector: 'app-divine-service-header',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, MatMenuModule, MatTooltipModule],
    templateUrl: './divine-service-header.component.html',
    styleUrl: './divine-service-header.component.scss'
})
export class DivineServiceHeaderComponent {
    @Input() service!: DivineServiceDetailDto;
    @Input() unitId: string | null = null;
    @Input() totalAdults = 0;
    @Input() totalMinors = 0;

    @Output() back = new EventEmitter<void>();
    @Output() edit = new EventEmitter<void>();
    @Output() delete = new EventEmitter<void>();
    @Output() closeAttendance = new EventEmitter<void>();
    @Output() attendanceDetail = new EventEmitter<void>();
    @Output() goToList = new EventEmitter<void>();

    readonly canManageDivineServices$ = inject(UserFullInfoService).canManageDivineServices$;

    get attendanceTotal(): number {
        return this.totalAdults + this.totalMinors;
    }

    formatDate(dateTime: string): string {
        const [datePart] = dateTime.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        const weekday = date.toLocaleDateString('es-AR', { weekday: 'long' });
        const monthName = date.toLocaleDateString('es-AR', { month: 'long' });
        return `${weekday} ${day} de ${monthName} de ${year}`;
    }

    formatMobileDate(dateTime: string): string {
        const [datePart] = dateTime.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        const weekday = date.toLocaleDateString('es-AR', { weekday: 'short' }).replace('.', '');
        return `${weekday} ${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
    }
}
